import BaseApi from './baseApi';
import { API_BASE_URL, AUTH_ENDPOINTS } from './endpoints';
import {
  AuthResponse,
  SignUpRequest,
  SignInRequest,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  VerifyOtpRequest,
  VerifyOtpResponse,
  SetPasswordRequest,
  SetPasswordResponse,
  ChangePasswordRequest,
  ApiResponse,
} from './types';
import { clearAuthData } from './logoutUtil';

class AuthApi extends BaseApi {
  constructor() {
    super(API_BASE_URL);
  }

  async signUp(data: SignUpRequest): Promise<ApiResponse<AuthResponse>> {
    return this.post<ApiResponse<AuthResponse>>(AUTH_ENDPOINTS.SIGN_UP, data);
  }

  /** Cookie-based login — tokens are set via Set-Cookie; body has no JWTs. */
  async signIn(data: SignInRequest): Promise<AuthResponse> {
    return this.post<AuthResponse>(AUTH_ENDPOINTS.SIGN_IN, data);
  }

  async forgotPassword(data: ForgotPasswordRequest): Promise<ForgotPasswordResponse> {
    return this.post<ForgotPasswordResponse>(AUTH_ENDPOINTS.FORGOT_PASSWORD, data);
  }

  async verifyOtp(data: VerifyOtpRequest): Promise<VerifyOtpResponse> {
    return this.post<VerifyOtpResponse>(AUTH_ENDPOINTS.VERIFY_OTP, data);
  }

  async setPassword(data: SetPasswordRequest): Promise<SetPasswordResponse> {
    return this.post<SetPasswordResponse>(AUTH_ENDPOINTS.SET_PASSWORD, data);
  }

  async changePassword(data: ChangePasswordRequest): Promise<ApiResponse<void>> {
    return this.post<ApiResponse<void>>(AUTH_ENDPOINTS.CHANGE_PASSWORD, data);
  }

  async verifyEmail(token: string): Promise<ApiResponse<void>> {
    return this.post<ApiResponse<void>>(AUTH_ENDPOINTS.VERIFY_EMAIL, { token });
  }

  /** Silent cookie refresh — refresh token is read from the cookie by the backend. */
  async refreshToken(): Promise<void> {
    if (typeof window === 'undefined') return;
    await this.post<AuthResponse>(AUTH_ENDPOINTS.REFRESH_TOKEN, {});
  }

  async logout(): Promise<void> {
    try {
      await this.post<AuthResponse>(AUTH_ENDPOINTS.LOGOUT, {});
    } catch {
      // Still clear local state even if the network call fails
    } finally {
      clearAuthData();
    }
  }
}

export const authApi = new AuthApi();
